export const formatCurrency = (value: number, language = 'pt-BR', currency = 'BRL') => new Intl.NumberFormat(language, { style: 'currency', currency }).format(Number(value));
